import { __decorate } from "tslib";
import { EventBus } from '@/plugins/event-bus';
import rooms from '@sicfe/rooms/src/pages/Rooms.vue';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const roomStore = namespace('RoomStore');
const controllerStore = namespace('ControllerStore');
let Rooms = class Rooms extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
    }
    async created() {
        await this.fetchRooms(this.controllerId);
        await this.fetchControllers();
        this.loading = false;
        EventBus.$on('roomDetail', (route) => {
            this.$router.push({
                name: 'roomDetails',
                params: {
                    id: route.route.params.id,
                    roomId: route.roomId.toString(),
                },
            });
        });
    }
    get controllerName() {
        return this.controllers.filter((controller) => {
            return controller.id === this.controllerId;
        })[0].name;
    }
    get controllerId() {
        return Number(this.$route.params.id);
    }
};
__decorate([
    controllerStore.State('controllers')
], Rooms.prototype, "controllers", void 0);
__decorate([
    controllerStore.Action('fetch')
], Rooms.prototype, "fetchControllers", void 0);
__decorate([
    roomStore.State('rooms')
], Rooms.prototype, "rooms", void 0);
__decorate([
    roomStore.Action('fetch')
], Rooms.prototype, "fetchRooms", void 0);
Rooms = __decorate([
    Component({
        components: {
            rooms,
        },
    })
], Rooms);
export default Rooms;
